var map = {
	"./section4_pic1.png": "ddcc",
	"./section4_pic1@2x.png": "aa91",
	"./section4_pic1@3x.png": "3d82",
	"./section4_pic2.png": "2246",
	"./section4_pic2@2x.png": "cba2",
	"./section4_pic2@3x.png": "ac42"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b102";